export const BetaFigmaUserIDs = [
  '383754125047657632', // Liam
];
